import type { ReactNode } from 'react'

type PlansListChromeProps = {
  /** From `headerAppearance.chromeBackground`. */
  background: string
  children: ReactNode
}

/**
 * One gradient paint behind hero + filters/context.
 * Top header stays on solid `backgroundColor` (gradient top stop) so bands don’t restart.
 */
export function PlansListChrome({ background, children }: PlansListChromeProps) {
  return <div style={{ background }}>{children}</div>
}
